import { Divider } from '@mui/material';
import EarningBox from './components/EarningBox';
import PlaybackStats from './components/PlaybackStats';
import ReleasesStats from './components/ReleasesStats';
import ReleaseTabView from './components/ReleaseTabView';
import { ReleaseInfoContainer } from './styled';

const ReleasesContent = () => (
  <>
    <ReleaseInfoContainer>
      <EarningBox />
      <PlaybackStats />
      <ReleasesStats />
    </ReleaseInfoContainer>

    <Divider />
    <ReleaseTabView />
  </>
);

export default ReleasesContent;
